import { isNilOrEmpty } from 'utils/fp'
import { getActiveRegion } from 'api-client/helpers'
interface KaapiMachineDeploymentParams {
  name: string
  namespace: string
  autoscaling?: { max: number }
  clusterName: string
  replicas: number
  configTemplateRefName: string
  infrastructureRefName: string
  k8sVersion: string
  openstackCluster: string
  isBYOCluster?: boolean
}

export const createKaapiMachineDeploymentBody = ({
  name,
  namespace,
  autoscaling,
  clusterName,
  replicas,
  configTemplateRefName,
  infrastructureRefName,
  k8sVersion,
  openstackCluster,
  isBYOCluster,
}: KaapiMachineDeploymentParams) => {
  const enableAutoscaling = !isNilOrEmpty(autoscaling)
  const autoscalingAnnotations = enableAutoscaling
    ? {
        'cluster.x-k8s.io/cluster-api-autoscaler-node-group-max-size': autoscaling.max.toString(),
        'cluster.x-k8s.io/cluster-api-autoscaler-node-group-min-size': replicas.toString(),
      }
    : {}

  return {
    apiVersion: 'cluster.x-k8s.io/v1beta1',
    kind: 'MachineDeployment',
    metadata: {
      name,
      namespace,
      annotations: {
        ...autoscalingAnnotations,
      },
      labels: {
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
      },
    },
    spec: {
      clusterName,
      replicas,
      template: {
        metadata: {
          labels: {
            'pcd-kaapi.pf9.io/region': getActiveRegion(),
          },
        },
        spec: {
          bootstrap: {
            configRef: {
              apiVersion: 'bootstrap.cluster.x-k8s.io/v1beta1',
              kind: 'KubeadmConfigTemplate',
              name: configTemplateRefName,
            },
          },
          clusterName: clusterName,
          // Failure domain is not required for BYO clusters
          ...(isBYOCluster ? {} : { failureDomain: openstackCluster }),
          infrastructureRef: {
            apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
            kind: isBYOCluster ? 'ByoMachineTemplate' : 'OpenStackMachineTemplate',
            name: infrastructureRefName,
          },
          version: k8sVersion,
        },
      },
    },
  }
}
